/**
 * Workbench student-tasks 域 RPC 契约（apps/workbench student-tasks，1 端点）。
 *
 * 学员任务上下文（当前学员的班期、小组与任务；小组成员关系是提交资格事实，
 * 不依赖订单/报名状态；服务端从 CurrentUser.studentId 取，不取客户端输入）。
 * 权限：IN_CLASS_TASK_READ_ALL。
 */
import * as Rpc from "effect/unstable/rpc/Rpc";
import * as RpcGroup from "effect/unstable/rpc/RpcGroup";
import { undefinedInputSchema } from "@crm/effect/schema";
import { asContractSchema, RpcAppError } from "../errors";
import { RpcAuthMiddleware } from "../middleware";
import { Schema } from "effect";

/** 班级任务（Date 字段在 effect 层已转 epoch 毫秒） */
const StudentTaskSchema = Schema.Struct({
  id: Schema.String,
  title: Schema.String,
  description: Schema.NullOr(Schema.String),
  deadline: Schema.NullOr(Schema.Finite),
  createdAt: Schema.Finite,
  status: Schema.String,
  type: Schema.Literals(["in_class", "evening", "mikequan"]),
  canSubmit: Schema.Boolean,
});

const StudentTaskContextClassSessionSchema = Schema.Struct({
  classSessionId: Schema.String,
  classSessionName: Schema.String,
  enrollmentStatus: Schema.String,
  classSessionStartDate: Schema.NullOr(Schema.Finite),
  classSessionEndDate: Schema.NullOr(Schema.Finite),
  groupId: Schema.NullOr(Schema.String),
  groupName: Schema.NullOr(Schema.String),
  tasks: Schema.Array(StudentTaskSchema),
});

export const StudentTaskContextSchema = Schema.Struct({
  success: Schema.Literal(true),
  data: Schema.Struct({
    classSessions: Schema.Array(StudentTaskContextClassSessionSchema),
  }),
});
export type StudentTaskContext = Schema.Schema.Type<typeof StudentTaskContextSchema>;

export class StudentTasksRpc extends RpcGroup.make(
  Rpc.make("getStudentTaskContext", {
    payload: asContractSchema(undefinedInputSchema),
    success: StudentTaskContextSchema,
    error: RpcAppError,
  }),
).middleware(RpcAuthMiddleware) {}
